import { formatDateForTable } from '../../../utils/formatDate';
import { Box, Typography } from '@mui/material';
import TableActionPopup from '../../../components/Incidents/TableActionPopup';
import FirstArrivingUnit from '../../../components/Incidents/FirstArrivingUnit';
import { statusMatching } from '../utils/statusMatching';
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter';
import { ReactComponent as NoteIcon } from '../../../assets/notes.svg';

export const useIncidentsColumns = ({
  openIncidentInfo,
  handlerSyncNeris,
  setOpenCreateNoteModal,
}) => {
  return [
    {
      field: 'dispatch_time',
      headerName: 'Dispatch Time',
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      renderCell: ({ value }) => {
        const date = formatDateForTable(value);

        return (
          <Box>
            <Typography
              sx={{
                fontWeight: 'bold',
              }}
            >
              {date.formattedDate}
            </Typography>
            <Typography>{date.formattedTime}</Typography>
          </Box>
        );
      },
    },
    {
      field: 'incident_number',
      headerName: 'Number',
      flex: 1,
      maxWidth: 100,
      renderCell: ({ value, row }) => (
        <Typography
          onClick={() => openIncidentInfo(row.incident_id)}
          sx={{
            cursor: 'pointer',
            textDecoration: 'underline',
            color: 'blue',
            '&:hover': {
              color: 'darkblue',
            },
          }}
        >
          {value}
        </Typography>
      ),
    },
    {
      field: 'incident_type',
      headerName: 'Type',
      flex: 1,
      maxWidth: 300,
      valueGetter: ({ value }) => value || 'N/A',
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 2,
      // valueGetter: ({ value }) => getIncidentAddress(value),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      renderCell: ({ value }) => {
        return (
          <Box
            sx={{
              background:
                value.toLowerCase() === 'closed' ? '#F3F3F3' : '#FFF89A',
              padding: '5px 15px',
              borderRadius: '3px',
            }}
          >
            {capitalizeFirstLetter(value)}
          </Box>
        );
      },
    },
    {
      field: 'first_arriving_unit',
      headerName: '1st Arriving Unit',
      flex: 1,
      maxWidth: 150,
      minWidth: 120,
      renderCell: ({ value, row }) => {
        return (
          <FirstArrivingUnit firstUnit={value} units={row.responded_units} />
        );
      },
    },
    // {
    //   field: 'shift',
    //   headerName: 'Shift',
    //   flex: 1,
    //   maxWidth: 80,
    //   valueGetter: ({ value }) => 'Day',
    // },
    // {
    //   field: 'OfficerInCharge',
    //   headerName: 'Officer in Charge',
    //   flex: 1,
    //   maxWidth: 250,
    //   valueGetter: ({ value }) => {
    //     const storedName = localStorage.getItem('user');
    //     if (storedName) {
    //       const userName = JSON.parse(storedName);
    //       return userName.fullName;
    //     } else return '';
    //   },
    // },
    {
      field: 'neris_status',
      headerName: 'NERIS Status',
      flex: 1,
      minWidth: 120,
      maxWidth: 150,
      renderCell: ({ value }) => {
        const status = statusMatching(value);

        return (
          <Box
            sx={{
              background: status.bg,
              padding: '5px 15px',
              borderRadius: '99px',
              color: status.color,
            }}
          >
            {status.text}
          </Box>
        );
      },
    },
    {
      field: 'trt',
      headerName: 'TRT',
      flex: 1,
      maxWidth: 80,
      valueGetter: ({ value }) =>
        new Date(value * 1000).toISOString().substr(11, 8),
    },
    {
      field: 'note',
      headerName: 'Notes',
      flex: 1,
      maxWidth: 80,
      renderCell: (params) => {
        const isHasNote = params.row.has_note;
        return (
          <Box
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => {
              setOpenCreateNoteModal({ id: params.id, isHasNote });
            }}
          >
            <NoteIcon
              style={{
                fill: isHasNote ? '#94e783' : 'none',
              }}
            />
          </Box>
        );
      },
    },
    {
      field: 'Action',
      headerName: 'Actions',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      flex: 1,
      maxWidth: 73,
      renderCell: (params) => {
        return (
          <>
            <TableActionPopup
              params={params}
              openIncidentInfo={openIncidentInfo}
              handlerSyncNeris={handlerSyncNeris}
            />
          </>
        );
      },
    },
  ];
};

export default useIncidentsColumns;
